import styled from "styled-components";

export const StyledFooter = styled.footer`
    display: flex;
    justify-content: center;
    padding-block: 1rem;
    color: var(--black-muted-softer);
    margin-top: 4rem;
`